var _clipPath, _clipPath2, _clipPath3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3840 2160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.70701,0,0,1.70701,-1289.21,-700.939)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5987,0,0,0.5987,766.024,533.702)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.46497,0,0,1.47168,-581.768,-881.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1343.1,965.107C1340.35,960.604 1339.63,955.151 1341.14,950.096C1342.65,945.041 1346.23,940.857 1351.01,938.578C1418.85,906.278 1482.63,877.727 1536.57,852.764C1755.99,751.211 1976.34,730.072 2062.59,769.173C2140.21,804.363 2132.13,834.255 2088.82,866.59C2050.49,895.203 1778.58,987.566 1458.77,1123.41C1450.2,1127.05 1440.25,1123.88 1435.4,1115.96C1415.41,1083.29 1365.23,1001.27 1343.1,965.107Z",
    style: {
      fill: "url(#_Radial1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.84564,0,0,3.84564,-2015.55,-1909.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.276,595.214C959.616,581.33 910.435,574.823 879.779,577.407C878.432,577.54 877.255,578.373 876.68,579.598C876.105,580.823 876.218,582.261 876.977,583.382C882.491,591.853 893.562,609.884 903.752,632.696",
    style: {
      fill: "url(#_Radial2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.324939,0.398625,-0.609242,0.496623,778.829,633.581)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.087,
    y: 164.591,
    width: 184.698,
    height: 468.577
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.804,179.441C679.301,227.992 382.629,1050.93 659.232,1116.65C661.87,1117.28 654.346,1118.53 651.804,1118.53C554.271,1118.53 475.087,908.137 475.087,648.987C475.087,389.838 603.738,94.575 651.804,179.441Z",
    style: {
      fill: "url(#_Radial4)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.47293,-2.14526,-2.14526,-3.47293,-32.4327,4687.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.276,595.214C960.057,581.855 914.101,575.325 883.333,577.153C881.246,577.308 879.397,578.558 878.475,580.436C877.552,582.315 877.694,584.542 878.846,586.288C884.756,595.608 894.608,612.227 903.752,632.696",
    style: {
      fill: "url(#_Radial5)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.440892,0.619546,-0.608809,0.433252,467.921,-170.377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1718.65,1132.57C1721.74,1136.29 1722.43,1141.5 1720.41,1145.91C1718.39,1150.33 1714.04,1153.16 1709.26,1153.16L1256,1153.16C1251.11,1153.16 1246.68,1150.21 1244.73,1145.65C1242.77,1141.09 1243.65,1135.79 1246.98,1132.14C1298.92,1075.1 1439.97,920.207 1460.08,898.131C1461.61,896.447 1463.74,895.461 1466,895.393C1475.85,895.098 1503.7,894.264 1515.35,893.915C1518.64,893.817 1521.8,895.253 1523.93,897.816C1546.15,924.605 1672.31,1076.7 1718.65,1132.57Z",
    style: {
      fill: "url(#_Radial6)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,93.3118,-303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.505,1372.47C548.814,1370.15 548.122,1367.26 548.583,1364.43C549.044,1361.6 550.62,1359.07 552.958,1357.41C552.958,1357.41 552.959,1357.41 552.959,1357.41C838.15,1155.21 1228.76,1017.46 1159.91,1118.29C1140.53,1146.65 616.807,1408.01 616.059,1408.43C610.175,1411.7 604.296,1414.98 598.425,1418.28C592.576,1421.56 585.197,1419.95 581.24,1414.54C572.804,1402.99 558.686,1383.66 550.505,1372.47Z",
    style: {
      fill: "url(#_Radial7)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04832,0,0,1.04832,87.3449,-483.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.497,1390.64C661.661,1382.35 663.589,1370.91 671.818,1364.99C675.996,1361.99 680.197,1358.99 684.419,1356C1003.35,1129.87 1460.91,1005.05 1391.65,1128.73C1371.26,1165.14 1035.68,1291.85 731.207,1453.04C722.981,1457.41 712.792,1454.97 707.43,1447.36C696.583,1431.95 678.789,1406.68 667.497,1390.64Z",
    style: {
      fill: "url(#_Radial8)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12781,0,0,1.12781,55.0341,-410.463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M785.095,1123.39C782.646,1119.81 781.739,1115.39 782.578,1111.13C783.417,1106.87 785.931,1103.13 789.557,1100.74C1241.19,804.231 1816.92,631.899 1717.04,793.734C1688.32,840.267 1277.65,1010.42 871.562,1224.52C864.281,1228.37 855.276,1226.13 850.632,1219.34C835.116,1196.62 801.44,1147.32 785.095,1123.39Z",
    style: {
      fill: "url(#_Radial9)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19316,0,0,1.19316,-103.015,-486.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1033.27,1014.84C1027.71,1006.1 1030.15,994.514 1038.77,988.759C1495.62,685.329 2124.87,547.12 2034.95,728.388C2008.89,780.919 1561.11,935.892 1135.96,1144.71C1127.24,1149 1116.68,1146.04 1111.46,1137.83C1093.15,1109.03 1052.22,1044.64 1033.27,1014.84Z",
    style: {
      fill: "url(#_Radial10)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5987,0,0,0.5987,941.221,555.684)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.46497,0,0,1.47168,-581.768,-881.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1343.1,965.107C1340.35,960.604 1339.63,955.151 1341.14,950.096C1342.65,945.041 1346.23,940.857 1351.01,938.578C1418.85,906.278 1482.63,877.727 1536.57,852.764C1755.99,751.211 1976.34,730.072 2062.59,769.173C2140.21,804.363 2132.13,834.255 2088.82,866.59C2050.49,895.203 1778.58,987.566 1458.77,1123.41C1450.2,1127.05 1440.25,1123.88 1435.4,1115.96C1415.41,1083.29 1365.23,1001.27 1343.1,965.107Z",
    style: {
      fill: "url(#_Radial11)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.84564,0,0,3.84564,-2015.55,-1909.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.276,595.214C959.616,581.33 910.435,574.823 879.779,577.407C878.432,577.54 877.255,578.373 876.68,579.598C876.105,580.823 876.218,582.261 876.977,583.382C882.491,591.853 893.562,609.884 903.752,632.696",
    style: {
      fill: "url(#_Radial12)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.324939,0.398625,-0.609242,0.496623,778.829,633.581)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.087,
    y: 164.591,
    width: 184.698,
    height: 468.577
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.804,179.441C679.301,227.992 382.629,1050.93 659.232,1116.65C661.87,1117.28 654.346,1118.53 651.804,1118.53C554.271,1118.53 475.087,908.137 475.087,648.987C475.087,389.838 603.738,94.575 651.804,179.441Z",
    style: {
      fill: "url(#_Radial14)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.47293,-2.14526,-2.14526,-3.47293,-32.4327,4687.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.276,595.214C960.057,581.855 914.101,575.325 883.333,577.153C881.246,577.308 879.397,578.558 878.475,580.436C877.552,582.315 877.694,584.542 878.846,586.288C884.756,595.608 894.608,612.227 903.752,632.696",
    style: {
      fill: "url(#_Radial15)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.440892,0.619546,-0.608809,0.433252,467.921,-170.377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1718.65,1132.57C1721.74,1136.29 1722.43,1141.5 1720.41,1145.91C1718.39,1150.33 1714.04,1153.16 1709.26,1153.16L1256,1153.16C1251.11,1153.16 1246.68,1150.21 1244.73,1145.65C1242.77,1141.09 1243.65,1135.79 1246.98,1132.14C1298.92,1075.1 1439.97,920.207 1460.08,898.131C1461.61,896.447 1463.74,895.461 1466,895.393C1475.85,895.098 1503.7,894.264 1515.35,893.915C1518.64,893.817 1521.8,895.253 1523.93,897.816C1546.15,924.605 1672.31,1076.7 1718.65,1132.57Z",
    style: {
      fill: "url(#_Radial16)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,93.3118,-303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.505,1372.47C548.814,1370.15 548.122,1367.26 548.583,1364.43C549.044,1361.6 550.62,1359.07 552.958,1357.41C552.958,1357.41 552.959,1357.41 552.959,1357.41C838.15,1155.21 1228.76,1017.46 1159.91,1118.29C1140.53,1146.65 616.807,1408.01 616.059,1408.43C610.175,1411.7 604.296,1414.98 598.425,1418.28C592.576,1421.56 585.197,1419.95 581.24,1414.54C572.804,1402.99 558.686,1383.66 550.505,1372.47Z",
    style: {
      fill: "url(#_Radial17)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04832,0,0,1.04832,87.3449,-483.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.497,1390.64C661.661,1382.35 663.589,1370.91 671.818,1364.99C675.996,1361.99 680.197,1358.99 684.419,1356C1003.35,1129.87 1460.91,1005.05 1391.65,1128.73C1371.26,1165.14 1035.68,1291.85 731.207,1453.04C722.981,1457.41 712.792,1454.97 707.43,1447.36C696.583,1431.95 678.789,1406.68 667.497,1390.64Z",
    style: {
      fill: "url(#_Radial18)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12781,0,0,1.12781,55.0341,-410.463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M785.095,1123.39C782.646,1119.81 781.739,1115.39 782.578,1111.13C783.417,1106.87 785.931,1103.13 789.557,1100.74C1241.19,804.231 1816.92,631.899 1717.04,793.734C1688.32,840.267 1277.65,1010.42 871.562,1224.52C864.281,1228.37 855.276,1226.13 850.632,1219.34C835.116,1196.62 801.44,1147.32 785.095,1123.39Z",
    style: {
      fill: "url(#_Radial19)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19316,0,0,1.19316,-103.015,-486.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1033.27,1014.84C1027.71,1006.1 1030.15,994.514 1038.77,988.759C1495.62,685.329 2124.87,547.12 2034.95,728.388C2008.89,780.919 1561.11,935.892 1135.96,1144.71C1127.24,1149 1116.68,1146.04 1111.46,1137.83C1093.15,1109.03 1052.22,1044.64 1033.27,1014.84Z",
    style: {
      fill: "url(#_Radial20)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82191,0,0,2.2804,-106.345,-796.359)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "886.245px",
    y: "995.943px",
    style: {
      fontFamily: "'Android101', 'Android 101'",
      fontSize: 144,
      fill: "url(#_Radial21)"
    }
  }, "Maxfish")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5987,0,0,0.5987,1114.28,582.36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.46497,0,0,1.47168,-581.768,-881.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1343.1,965.107C1340.35,960.604 1339.63,955.151 1341.14,950.096C1342.65,945.041 1346.23,940.857 1351.01,938.578C1418.85,906.278 1482.63,877.727 1536.57,852.764C1755.99,751.211 1976.34,730.072 2062.59,769.173C2140.21,804.363 2132.13,834.255 2088.82,866.59C2050.49,895.203 1778.58,987.566 1458.77,1123.41C1450.2,1127.05 1440.25,1123.88 1435.4,1115.96C1415.41,1083.29 1365.23,1001.27 1343.1,965.107Z",
    style: {
      fill: "url(#_Radial22)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.84564,0,0,3.84564,-2015.55,-1909.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.276,595.214C959.616,581.33 910.435,574.823 879.779,577.407C878.432,577.54 877.255,578.373 876.68,579.598C876.105,580.823 876.218,582.261 876.977,583.382C882.491,591.853 893.562,609.884 903.752,632.696",
    style: {
      fill: "url(#_Radial23)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.324939,0.398625,-0.609242,0.496623,778.829,633.581)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.087,
    y: 164.591,
    width: 184.698,
    height: 468.577
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.804,179.441C679.301,227.992 382.629,1050.93 659.232,1116.65C661.87,1117.28 654.346,1118.53 651.804,1118.53C554.271,1118.53 475.087,908.137 475.087,648.987C475.087,389.838 603.738,94.575 651.804,179.441Z",
    style: {
      fill: "url(#_Radial25)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.47293,-2.14526,-2.14526,-3.47293,-32.4327,4687.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.276,595.214C960.057,581.855 914.101,575.325 883.333,577.153C881.246,577.308 879.397,578.558 878.475,580.436C877.552,582.315 877.694,584.542 878.846,586.288C884.756,595.608 894.608,612.227 903.752,632.696",
    style: {
      fill: "url(#_Radial26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.440892,0.619546,-0.608809,0.433252,467.921,-170.377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1718.65,1132.57C1721.74,1136.29 1722.43,1141.5 1720.41,1145.91C1718.39,1150.33 1714.04,1153.16 1709.26,1153.16L1256,1153.16C1251.11,1153.16 1246.68,1150.21 1244.73,1145.65C1242.77,1141.09 1243.65,1135.79 1246.98,1132.14C1298.92,1075.1 1439.97,920.207 1460.08,898.131C1461.61,896.447 1463.74,895.461 1466,895.393C1475.85,895.098 1503.7,894.264 1515.35,893.915C1518.64,893.817 1521.8,895.253 1523.93,897.816C1546.15,924.605 1672.31,1076.7 1718.65,1132.57Z",
    style: {
      fill: "url(#_Radial27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,93.3118,-303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.505,1372.47C548.814,1370.15 548.122,1367.26 548.583,1364.43C549.044,1361.6 550.62,1359.07 552.958,1357.41C552.958,1357.41 552.959,1357.41 552.959,1357.41C838.15,1155.21 1228.76,1017.46 1159.91,1118.29C1140.53,1146.65 616.807,1408.01 616.059,1408.43C610.175,1411.7 604.296,1414.98 598.425,1418.28C592.576,1421.56 585.197,1419.95 581.24,1414.54C572.804,1402.99 558.686,1383.66 550.505,1372.47Z",
    style: {
      fill: "url(#_Radial28)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04832,0,0,1.04832,87.3449,-483.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.497,1390.64C661.661,1382.35 663.589,1370.91 671.818,1364.99C675.996,1361.99 680.197,1358.99 684.419,1356C1003.35,1129.87 1460.91,1005.05 1391.65,1128.73C1371.26,1165.14 1035.68,1291.85 731.207,1453.04C722.981,1457.41 712.792,1454.97 707.43,1447.36C696.583,1431.95 678.789,1406.68 667.497,1390.64Z",
    style: {
      fill: "url(#_Radial29)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12781,0,0,1.12781,55.0341,-410.463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M785.095,1123.39C782.646,1119.81 781.739,1115.39 782.578,1111.13C783.417,1106.87 785.931,1103.13 789.557,1100.74C1241.19,804.231 1816.92,631.899 1717.04,793.734C1688.32,840.267 1277.65,1010.42 871.562,1224.52C864.281,1228.37 855.276,1226.13 850.632,1219.34C835.116,1196.62 801.44,1147.32 785.095,1123.39Z",
    style: {
      fill: "url(#_Radial30)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19316,0,0,1.19316,-103.015,-486.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1033.27,1014.84C1027.71,1006.1 1030.15,994.514 1038.77,988.759C1495.62,685.329 2124.87,547.12 2034.95,728.388C2008.89,780.919 1561.11,935.892 1135.96,1144.71C1127.24,1149 1116.68,1146.04 1111.46,1137.83C1093.15,1109.03 1052.22,1044.64 1033.27,1014.84Z",
    style: {
      fill: "url(#_Radial31)"
    }
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2118.6,8.41055,-8.44906,2108.95,601.757,1218.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(807.068,3.21862,-3.21862,807.068,602.069,733.737)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3831.74,-3050.7,4662.56,2507.1,-168.192,696.581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(645.269,-402.152,-402.152,-645.269,555.257,744.034)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2379.82,-3374.55,3316.07,2421.79,1032.04,1023.55)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3103.7,12.3777,-12.3777,3103.7,206.478,1215.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2960.64,11.8071,-11.8071,2960.64,202.653,1331.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2751.98,10.975,-10.975,2751.98,217.019,1173.02)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2601.23,10.3738,-10.3738,2601.23,337.594,1172.73)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial11",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2118.6,8.41055,-8.44906,2108.95,402.007,1193.84)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial12",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(807.068,3.21862,-3.21862,807.068,525.975,724.189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial14",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3831.74,-3050.7,4662.56,2507.1,-583.044,955.636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial15",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(645.269,-402.152,-402.152,-645.269,498.995,789.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2379.82,-3374.55,3316.07,2421.79,769.568,1314.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial17",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3103.7,12.3777,-12.3777,3103.7,-86.1505,1178.76)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial18",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2960.64,11.8071,-11.8071,2960.64,-76.4878,1296.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial19",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2751.98,10.975,-10.975,2751.98,-42.4477,1140.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2601.23,10.3738,-10.3738,2601.23,92.3394,1141.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1019.91,3.24965,-4.06743,814.851,577.335,822.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2118.6,8.41055,-8.44906,2108.95,204.7,1163.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial23",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(807.068,3.21862,-3.21862,807.068,450.813,712.603)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial25",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3831.74,-3050.7,4662.56,2507.1,-1005.31,1204.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(645.269,-402.152,-402.152,-645.269,444.488,835.858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial27",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2379.82,-3374.55,3316.07,2421.79,501.43,1594.73)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial28",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3103.7,12.3777,-12.3777,3103.7,-375.2,1134.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2960.64,11.8071,-11.8071,2960.64,-352.214,1253.87)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial30",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2751.98,10.975,-10.975,2751.98,-298.741,1100.95)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2601.23,10.3738,-10.3738,2601.23,-149.915,1104.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(175,175,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(142,145,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(130,134,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17,29,74)",
      stopOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aa51161b07d2a706d777a560056d219d.svg";
export { ForwardRef as ReactComponent };